import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import Text from "_shared/text/text";

export default class ProjectName extends Text {
  public static create(value: ProjectName | string): ProjectName {
    if (value instanceof ProjectName) {
      return value;
    }
    return new ProjectName(value);
  }

  public static fromJSON(value: unknown): ProjectName | null | undefined {
    if (isNullOrUndefined(value)) return value;
    if (typeof value !== "string") throw new Error("Cannot create ProjectName from non-string value");
    return new ProjectName(value);
  }

  constructor(value: string) {
    super(value.trim());
  }

  public toJSON(): string {
    return this.value;
  }

  public isEqualTo(other: ProjectName | null | undefined): boolean {
    if (!other) return false;

    if (!(other instanceof ProjectName)) {
      console.warn("Comparing ProjectName to non-ProjectName instance");
      return false;
    }

    return super.isEqualTo(other);
  }
}
